<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="导出类型：">
        <el-select v-model="excelType" placeholder="请选择" clearable size="small">
          <el-option label="订单导出" :value="1"></el-option>
          <el-option label="产品明细" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型：" v-if="orderType != 2">
        <el-select v-model="query.orderType" placeholder="请选择" clearable size="small">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="订货订单" :value="1"></el-option>
          <el-option label="秒杀订单" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：">
        <el-select v-model="query.state" placeholder="请选择" clearable size="small">
          <el-option label="待支付" :value="1"></el-option>
          <el-option label="待发货" :value="2"></el-option>
          <el-option label="已发货" :value="3"></el-option>
          <el-option label="已完成" :value="4"></el-option>
          <el-option label="已取消" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="支付时间：">
        <el-date-picker v-model="payTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="城市公司" prop="cityId" class="width100">
        <el-select id="cityId" v-model="query.cityId" placeholder="请选择城市公司" filterable size="small" clearable>
          <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  props: ['orderType'],
  data() {
    return {
      dateTime: [],
      payTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        state: undefined,
        orderType: 1,
        cityId: undefined
      },
      excelType: 1,
      categorizeIdArr: [],
      categorizeOptions: [],  //商品分类
      cityCompanyOptions: []
    }
  },
  created() {
    this.query.orderType = this.orderType;
    this.getCityCompany()
  },
  methods: {
    handleDownload() {
      if (!this.excelType) return this.$message.error('请选择导出类型')
      // if (!this.query.state) return this.$message.error('请选择订单状态')
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.payTimeStart = this.payTime && this.payTime.length > 0 ? this.payTime[0] : undefined
      this.query.payTimeEnd = this.payTime && this.payTime.length > 0 ? this.payTime[1] : undefined
      //订单类型 全部=-1 1订货订单 2积分订单 3秒杀订单"，

      // 构建导出参数，将 cityId 映射为 cityCompanyId
      let exportParams = { ...this.query }
      if (exportParams.cityId !== undefined && exportParams.cityId !== null && exportParams.cityId !== '') {
        exportParams.cityCompanyId = exportParams.cityId
      }
      // 删除 query 中的 cityId，使用 cityCompanyId
      delete exportParams.cityId

      let Ins = this.excelType === 1 ? goodsOrderApi.coustomerOrderExportExcel : goodsOrderApi.coustomerOrderGoodsExportExcel;
      console.log(Ins)
      return this.$common.confirm('是否确认导出')
        .then(() => Ins(exportParams)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },
      //获取城市公司
      getCityCompany() {
      cityCompanyApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(res => {
        this.cityCompanyOptions = res.data.list || []
      }).catch(err => {
        console.error('获取城市公司列表失败:', err)
        this.cityCompanyOptions = []
      })
    },

  }

}
</script>

<style>
</style>